<template>
  <div>
    <v-card>
      <v-toolbar flat dense>
        <!-- <v-toolbar-title>Totem</v-toolbar-title> -->
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row dense class="pl-2 pr-2 pb-2">
        <!-- themes -->
        <v-col v-for="(item, idxD) of tema.themes" :key="idxD" cols="3">
          <v-sheet
            color="green lighten-5"
            width="100%"
            class="pt-2 pb-2 pl-2 pr-2"
          >
            <v-row class="ml-1">
              <v-col cols="12">
                <h4 class="mb-2">
                  Tema: {{ tema.themes[idxD].title || tema.themes[idxD].name }}
                </h4>
              </v-col>
            </v-row>
            <v-card class="mx-auto" :disabled="loading || saving">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>Colori</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-text
                        v-for="key in Object.keys(tema.themes[idxD].colors)"
                        :key="key"
                      >
                        {{ key }}
                        <v-color-picker
                          mode="hexa"
                          v-model="tema.themes[idxD].colors[key]"
                        ></v-color-picker>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Testi</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-title>Dimensioni</v-card-title>
                      <v-card-text>
                        tiny
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.tiny[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        small
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.small[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        medium
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.medium[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        large
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.large[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        huge
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.huge[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        title
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.huge[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        biggest
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].texts.size.huge[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Ombre</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-title>Dimensioni</v-card-title>
                      <v-card-text>
                        small
                        <v-row no-gutters justify="space-between">
                          <v-col
                            v-for="(el, idx) in tema.themes[idxD].shadows.small"
                            :key="idx"
                          >
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.color"
                              label="color"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.spread"
                              label="spread"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.offset"
                              label="offset"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.radius"
                              label="radius"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        medium
                        <v-row no-gutters justify="space-between">
                          <v-col
                            v-for="(el, idx) in tema.themes[idxD].shadows
                              .medium"
                            :key="idx"
                          >
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.color"
                              label="color"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.spread"
                              label="spread"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.offset"
                              label="offset"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.radius"
                              label="radius"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        large
                        <v-row no-gutters justify="space-between">
                          <v-col
                            v-for="(el, idx) in tema.themes[idxD].shadows.large"
                            :key="idx"
                          >
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.color"
                              label="color"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.spread"
                              label="spread"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.offset"
                              label="offset"
                            ></v-text-field>
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="el.radius"
                              label="radius"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Bordi</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-title>Dimensioni</v-card-title>
                      <v-card-text>
                        small
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].border.radius.small[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        medium
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].border.radius.medium[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        large
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].border.radius.large[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header>Padding</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card flat>
                      <v-card-title>Dimensioni</v-card-title>
                      <v-card-text>
                        small
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="tema.themes[idxD].padding.small[idx - 1]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        medium
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="
                                tema.themes[idxD].padding.medium[idx - 1]
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
                        large
                        <v-row no-gutters justify="space-between">
                          <v-col v-for="idx in numDimensioni" :key="idx">
                            <v-text-field
                              class="text-caption pr-2 pl-2"
                              v-model="tema.themes[idxD].padding.large[idx - 1]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>
      <v-btn
        class="mt-2 mb-3"
        color="success"
        :loading="saving"
        @click.stop="onSalvaModifiche"
        >Salva modifiche</v-btn
      >
    </v-card>
    <v-dialog v-model="dialogInfo" max-width="500" :persistent="true">
      <v-card>
        <v-card-title class="text-h5">{{ dialogTitle }}</v-card-title>
        <!-- eslint-disable-next-line-->
        <v-card-text v-html="markdownInfo"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="infoConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" max-width="1000" :persistent="true">
      <v-card>
        <v-card-title class="text-h5">
          {{ dialogEditTitle }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            title="Ulteriori informazioni"
            v-show="itemEdit && itemEdit.info"
          >
            <v-icon color="grey lighten-1" @click="mostraInfo(itemEdit)"
              >mdi-information</v-icon
            >
          </v-btn>
        </v-card-title>
        <v-container>
          <v-row dense>
            <v-col
              v-for="(ed, idx) in editInfo"
              class="pl-3 pr-3"
              cols="12"
              sm="12"
              md="6"
              :key="idx"
            >
              <v-text-field
                v-if="ed.type === 'text'"
                :label="ed.label"
                v-model="ed.value"
                :hint="ed.hint"
                :persistent-hint="ed.persistent"
                :required="ed.required"
                :rules="ed.rules"
              ></v-text-field>
              <v-switch
                v-else-if="ed.type === 'boolean'"
                v-model="ed.value"
                :label="ed.title || ed.name"
                :hint="ed.description"
                :persistent-hint="true"
                inset
              ></v-switch>
              <template v-else-if="ed.type === 'color'">
                <div>{{ ed.label }}</div>
                <v-color-picker
                  mode="hexa"
                  v-model="ed.value"
                  hide-canvas
                  hide-inputs
                ></v-color-picker>
                <div class="text-caption mb-3">{{ ed.hint }}</div>
              </template>
              <v-text-field
                v-else-if="ed.type === 'number'"
                :label="ed.label"
                v-model="ed.value"
                :hint="ed.hint"
                :persistent-hint="ed.persistent"
                :required="ed.required"
                :rules="ed.rules"
              ></v-text-field>
              <v-select
                v-else-if="ed.type === 'select'"
                :label="ed.label"
                v-model="ed.value"
                :hint="ed.hint"
                :persistent-hint="ed.persistent"
                :items="ed.source"
                item-text="descrizione"
                item-value="codice"
              ></v-select>
              <v-select
                v-else-if="ed.type === 'combo'"
                :label="ed.label"
                v-model="ed.value"
                :hint="ed.hint"
                :persistent-hint="ed.persistent"
                :items="ed.source"
                item-text="descrizione"
                item-value="codice"
                multiple
                chips
              ></v-select>
              <template v-else-if="ed.type === 'date'">
                <v-menu
                  v-model="menuData[idx]"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatDate(ed.value)"
                      label="Dalla data"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      hide-details
                      @click:clear="filtro.start = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ed.value"
                    no-title
                    scrollable
                    @input="menuData[idx] = false"
                  ></v-date-picker>
                </v-menu>
              </template>
              <!--               <template v-else-if="ed.type==='editor'">
                <v-json-editor v-model="ed.value" :options="optionsWeb" :plus="true" history @error="onErrorWeb" style="height: 100%;" ref="jsonEditor"/>
              </template> -->

              <span v-else>
                Controllo non gestito
              </span>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" text @click="dialogEdit = false"
            >Annulla</v-btn
          >
          <v-btn color="blue darken-1" text @click="editConfirm"
            >CONFERMA</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import configurazioni from "@/services/configurazioniService";
import _ from "lodash";

let TEMA = {};

export default {
  components: {},
  props: {
    item: Object,
    refresh: Number,
  },
  data() {
    return {
      loading: false,
      saving: false,
      daSalvare: false,
      tema: {},
      // configurazione: {},
      itemEditIdx: -1,
      itemEdit: null,
      editInfo: [],
      dialogEditTitle: "",
      editPosizione: "",
      dialogEdit: false,
      dialogInfo: false,
      dialogTitle: "",
      markdownInfo: "",
      menuData: {},
    };
  },
  beforeMount() {
    // this.tema = this.recursiveProxy(this.tema);
    window.addEventListener("beforeunload", this.preventNav);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  beforeRouteLeave(to, from, next) {
    if (this.modificheNonSalvate) {
      const answer = window.confirm(
        "Ci sono delle modifiche non salvate, confermi uscita ?"
      );
      if (!answer) return false;
    }
    next();
  },
  async mounted() {
    this.tema = this.$store.state.totem.theme;
    this.tema = this.recursiveProxy(this.tema);
    this.breakpoints = this.tema.breakpoints;
    this.themes = this.tema.themes;
  },
  computed: {
    items() {
      return this.struttura || [];
    },
    modificheNonSalvate() {
      return this.daSalvare;
    },
    mostraDeltaListino() {
      return (
        this.blocco &&
        parseFloat(this.blocco.prezzo) !== parseFloat(this.blocco.prezzoListino)
      );
    },
    numDimensioni() {
      return this.breakpoints.length + 1;
    },
    /*       globalConfig() {
        return Object.values(this.configurazione.breakpoints)
      } */
  },
  methods: {
    recursiveProxy(obj, path = []) {
      return new Proxy(obj, {
        get: (target, prop, receiver) => {
          const value = Reflect.get(target, prop, receiver);

          // Recursively wrap nested objects and arrays
          if (typeof value === "object" && value !== null) {
            return this.recursiveProxy(value, [...path, prop]);
          }
          return value;
        },
        set: (target, prop, value, receiver) => {
          // If assigning an object/array, wrap it with a proxy
          if (typeof value === "object" && value !== null) {
            value = this.recursiveProxy(value, [...path, prop]);
          }
          this.$store.commit("SET_THEME", { path: [...path, prop], value });

          // Reflectively set the value
          return Reflect.set(target, prop, value, receiver);
        },
      });
    },
    editVisibile(item) {
      return !_.isEmpty(item.config);
    },
    async onSalvaModifiche() {
      const totemDb = await configurazioni.getConfigurazione("totem");
      const oldTotem = totemDb.totem.findIndex(x=>x.codice===this.item.codice);
      totemDb.totem[oldTotem].tema = this.$store.state.totem.theme;
      await configurazioni.modificaConfigurazione(totemDb); 
    },
    async modificaValori(item, idx) {
      this.itemEditIdx = idx;
      this.itemEdit = item;
      this.editInfo = item.config;
      this.dialogEditTitle = item.title;
      this.dialogEdit = true;
    },
    mostraInfo(item) {
      // TODO: Nella nuova versione installare 'marked' per il parsing dell'md
      // const html = marked.parse(item.info)
      const html = item.info;
      this.markdownInfo = html;
      this.dialogTitle = item.title;
      this.dialogInfo = true;
    },
    editConfirm() {
      // this.aggiornaValore(this.itemEdit, this.editInfo)
      this.itemEditIdx = -1;
      this.dialogEdit = false;
    },
    infoConfirm() {
      this.dialogInfo = false;
    },
    preventNav(event) {
      if (!this.modificheNonSalvate) return;
      event.preventDefault();
      event.returnValue = "";
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
